import { Badge } from '@/components/ui/badge';

export function UserStatusBadge({ status }: { status: string }) {
  const variants: Record<
    string,
    'success' | 'info' | 'secondary' | 'destructive'
  > = {
    active: 'success',
    invited: 'info',
    disabled: 'secondary',
    removed: 'destructive',
  };
  return (
    <Badge variant={variants[status.toLowerCase()] ?? 'secondary'}>
      {status}
    </Badge>
  );
}
